---
title: "Как посчитать разницу между датами без таблиц и ручных формул"
description: "Практический сценарий для дедлайнов, отпусков и периодов: считаем дни, недели, месяцы и рабочие дни локально в браузере."
locale: "ru"
date: "2026-06-23"
tags: ["разница дат", "калькулятор дат", "локально"]
relatedTools: ["date-difference"]
translations:
  en: "how-to-calculate-date-difference"
faq:
  - q: "Даты отправляются на сервер?"
    a: "Нет. Калькулятор считает разницу прямо в браузере, выбранные даты не уходят в сеть."
  - q: "Почему месяцы и годы приблизительные?"
    a: "У месяцев разная длина, поэтому для быстрых оценок dateify показывает приближённое значение на основе дней."
---

Разница между двумя датами кажется простой, пока не появляется вопрос:
считать ли последний день, нужны ли только рабочие дни и что делать с
периодом, который захватывает несколько месяцев. В таблице это решается
формулами, но для разовой проверки быстрее открыть отдельный калькулятор.

Откройте [разницу между датами](/raznica-mezhdu-datami), выберите начальную
и конечную дату, затем включите нужные опции. dateify сразу покажет дни,
недели, примерные месяцы и годы. Если нужно считать период включительно,
поставьте галочку «Включая конечную дату».

## Где это полезно

Самые частые сценарии - отпуск, дедлайн, срок действия документа, учебный
период, договор или план работ. В таких задачах важно не только число дней,
но и понятное представление: две недели, несколько месяцев или конкретное
число рабочих дней.

Опция рабочих дней считает понедельник-пятницу и исключает субботу с
воскресеньем. Государственные праздники не вычитаются, поэтому для кадровых
или юридических расчётов результат лучше использовать как предварительную
оценку.

## Почему локальный расчёт удобнее

Даты сами по себе редко выглядят чувствительными, но в рабочем контексте
они часто связаны с договором, отпуском, больничным или внутренним сроком.
dateify не отправляет выбранные даты на сервер: расчёт выполняется в памяти
вкладки, а результат можно проверить через Network tab.
